import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CartPanel } from './CartPanel';
import { Toaster } from '../ui/sonner';
import { useSite } from '../../hooks/useSiteConfig';
import { SmartLink } from '../website/shared';

const AnnouncementBar = () => {
  const { globals } = useSite();
  const a = globals?.announcement;
  if (!a?.enabled || !a.text) return null;
  const dark = a.style !== 'light';
  return (
    <div data-testid="announcement-bar" className={`relative z-[60] text-center text-sm py-2.5 px-4 ${dark ? 'bg-[color:var(--site-accent)] text-white' : 'bg-[color:var(--site-surface)] text-neutral-900 border-b border-neutral-200'}`}>
      {a.text}{a.link && a.link_text && <SmartLink to={a.link} className="ml-2 underline underline-offset-4 font-medium">{a.link_text}</SmartLink>}
    </div>
  );
};

export const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && <Footer />}
      <CartPanel />
      <Toaster position="bottom-right" />
    </div>
  );
};
